module.exports = __webpack_public_path__ + "static/img/pix.b03e4db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pix.png
// module id = qw12
// module chunks = 2